module.exports = __webpack_public_path__ + "img/logo.d55aec4f.png";